import { observable } from 'mobx';

import Model from './Model';
import User from './User';
import currentUser from '../store/currentUser';
import Cycle from '../store/Cycle';


class Version extends Model {
  static basePath = '/api/versions';
  static verboseName = 'Version';

  @observable cycle_year;
  @observable cycle_month;
  @observable technology_family;
  @observable type;
  @observable name;
  @observable file;
  @observable version_file;
  @observable certified;
  @observable created_by;
  @observable created_at;
  @observable modified_at;
  @observable format;

  get verboseTechnologyFamily() {
    return this.getValueLabel('technology_family');
  }

  get verboseType() {
    return this.getValueLabel('type');
  }

  get cycle() {
    if (!this.isInitialized) {
      return null;
    }
    return new Cycle(this.cycle_year, this.cycle_month);
  }

  get cycleStr() {
    if (!this.isInitialized) {
      return null;
    }
    return this.cycle.toString();
  }

  get editUrl() {
    return `/input-files/${this.id}/edit`;
  }

  get createdByUser() {
    if (this.created_by) {
      return User.getForId(this.created_by);
    }
    return null;
  }

  toString() {
    if(this.name){
      return this.name;
    }
    return super.toString();
  }

  get canBeDownloaded() {
    return currentUser.can(`athena.download_${this.type}`);
  }

  get canBeEdited() {
    return (
      currentUser.can('athena.change_version')
      && currentUser.can(`athena.create_${this.type}`)
    );
  }

  get canBeCertified() {
    return this.canBeEdited && currentUser.can(`athena.certify_${this.type}`);
  }

  get canBeDeleted() {
    return (
      currentUser.can('athena.delete_version')
      && currentUser.can(`athena.delete_${this.type}`)
    );
  }
}


export default Version;
